import { render, staticRenderFns } from "./ViewBarHeader.vue?vue&type=template&id=2898ecdc&scoped=true&"
import script from "./ViewBarHeader.vue?vue&type=script&lang=js&"
export * from "./ViewBarHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewBarHeader.vue?vue&type=style&index=0&id=2898ecdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898ecdc",
  null
  
)

export default component.exports